import { AssistActions } from './../interface'

export const userMessagePrefix = {
  [AssistActions.SPELLING]: 'Improve Spelling and Grammar: ',
  [AssistActions.EXPAND]: 'Expand upon: ',
  [AssistActions.TRIM]: 'Trim Content: ',
  [AssistActions.TRANSLATE]: 'Translate: ',
  [AssistActions.TONE]: 'Change Tone: ',
  [AssistActions.GENERATE]: 'Learning Story: ',
}

export const aiResponsePrefix = {
  [AssistActions.SPELLING]: 'Improved: ',
  [AssistActions.EXPAND]: 'Expanded: ',
  [AssistActions.TRIM]: 'Trimmed: ',
  [AssistActions.TRANSLATE]: 'English: ',
  [AssistActions.GENERATE]: 'Learning story: ',
  [AssistActions.TONE]: 'Changed tone: ',
  ERROR: 'Request failed: ',
}
